import { useMutation, useQuery } from '@tanstack/react-query';
import { apiGet, apiPost } from '../lib/http.js';
import { ApiError } from '../lib/api.js';

const rsvpKey = (token) => ['rsvp', token];

async function fetchInvitacion(token) {
  return apiGet(`/api/confirmacion/${encodeURIComponent(token)}`);
}

async function postRsvp(token, payload) {
  return apiPost(`/api/confirmacion/${encodeURIComponent(token)}`, payload);
}

// Public hook that backs the Confirmacion page (FR-2).
// `token` comes from the URL. The query carries any error from the
// GET (404 → "Invitación no encontrada", 423 → backend message verbatim).
export function useConfirmacion(token) {
  const query = useQuery({
    queryKey: rsvpKey(token),
    queryFn: () => fetchInvitacion(token),
    retry: false,
    staleTime: 0,
  });

  const mutation = useMutation({
    mutationFn: (payload) => postRsvp(token, payload),
  });

  return { query, mutation };
}

// Extracts a friendly status from the query result so callers can render
// the right block: 404 / 423 / 200.
export function getConfirmacionStatus(query) {
  if (query.isLoading) return 'loading';
  if (query.error) {
    if (query.error instanceof ApiError && query.error.status === 404) return 'not-found';
    if (query.error instanceof ApiError && query.error.status === 423) return 'locked';
    return 'error';
  }
  if (query.data) return 'ready';
  return 'idle';
}